import { ms } from '@/utils/func'

export const ANGEL_USER_DATE = 1727740799000
export const THANKSGIVING_DEADLINE_TIME = 1764547200000
export const CHRISTMAS_DEADLINE_TIME = 1735776000000
export const CHRISTMAS_2025_DEADLINE_TIME = 1767657600000 // 2026-01-06 00:00 UTC
export const HALLOWEEN_2025_DEADLINE_TIME = ms(2025, 11, 1)
export const SUMMER_SALE_DEADLINE_TIME = 1752969600000
export const EASTER_BUNDLE_DEADLINE_TIME = ms(2026, 4, 27)
export const EASTER_PURCHASE_DEADLINE_TIME = ms(2026, 4, 27)
export const VALENTINE_DEALS_DEADLINE_TIME = ms(2026, 2, 23)
// 新用户充值入口日期
export const NEW_USER_SHOW_CHARGE_BEAN_DATE = 1743465600000
export const MAX_LENGTH_DEADLINE_TIME = 1758844800000

// 周年庆活动截止时间
export const ANNIVERSARY_DEADLINE_TIME = 1761955200000 // 对应 2025-10-31 24:00 (UTC)

// 万圣节活动时间
export const HALLOWEEN_START_TIME = ms(2025, 9, 22) // 活动开始时间：2025-10-22 00:00 (UTC)
export const HALLOWEEN_END_TIME = HALLOWEEN_2025_DEADLINE_TIME // 活动结束时间：2025-10-31 24:00 (UTC)

export const NEW_TAG_END_TIME = ms(2025, 11, 10)

export const NEW_REEL_CONTEST_END_TIME = ms(2025, 11, 24)

// 圣诞动画阶段时间
export const CHRISTMAS_ANIMATION_PHASE1_END = ms(2025, 12, 24, 23, 59, 59) // 第一阶段结束：12月24日 23:59:59
export const CHRISTMAS_ANIMATION_PHASE2_START = ms(2025, 12, 25, 0, 0, 0) // 第二阶段开始：12月25日 00:00:00
export const CHRISTMAS_ANIMATION_PHASE2_END = ms(2026, 1, 5, 23, 59, 59) // 第二阶段结束：1月5日 23:59:59

// 关系功能引导日期
export const RELATIONSHIP_GUIDE_DATE = 1763740800000

// 一月年费活动截止时间
export const JANUARY_ANNUAL_ACTIVITY_DEADLINE_TIME = 1769904000000 // 2026-02-01 08:00:00 (Beijing)
// 年付方案优惠截止时间：2026-07-03 00:00:00 UTC
export const ANNUAL_PLAN_SALE_DEADLINE_TIME = 1783036800000

// 情人节动画阶段时间
export const VALENTINE_ANIMATION_PHASE1_END = ms(2026, 2, 13, 23, 59, 59) // 第一阶段结束：2月13日 23:59:59
export const VALENTINE_ANIMATION_PHASE2_START = ms(2026, 2, 14, 0, 0, 0) // 第二阶段开始：2月14日 00:00:00
export const VALENTINE_ANIMATION_PHASE2_END = ms(2026, 2, 14, 23, 59, 59) // 第二阶段结束：2月14日 23:59:59
export const VALENTINE_ANIMATION_PHASE3_START = ms(2026, 2, 21, 0, 0, 0) // 第三阶段开始：2月21日 00:00:00
export const VALENTINE_ANIMATION_PHASE3_END = ms(2026, 2, 21, 23, 59, 59) // 第三阶段结束：2月21日 23:59:59
